import type { Client } from "@/api/schemas";
import { ClientBrand } from "@/components/clients/ClientBrand";
import { ClientPickerPopover } from "@/components/clients/ClientPickerPopover";
import type { Rol } from "@/routes/routeConfig";
import { NavIcon } from "./NavIcon";
import { UserMenu } from "./UserMenu";
import styles from "./MobileHeader.module.css";

interface MobileHeaderProps {
  rol: Rol;
  email: string;
  cliente: Client | null;
  clients: readonly Client[];
  recientes: readonly string[];
  onSelectClient: (client: Client) => void;
  onOpenSearch: () => void;
  onLogout: () => void;
}

/**
 * Cabecera fija de 56 px por debajo de 600 px (visual.md §4): la marca del cliente y la persona.
 * En agencia la marca es el selector de cliente y hay un botón de búsqueda (no hay ⌘K en el móvil);
 * en la tienda es solo la marca.
 */
export function MobileHeader({ rol, email, cliente, clients, recientes, onSelectClient, onOpenSearch, onLogout }: MobileHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.marca}>
        {rol === "agency" ? (
          <ClientPickerPopover variant="cabecera" clients={clients} actual={cliente} recientes={recientes} onSelect={onSelectClient} />
        ) : cliente ? (
          <div className={styles.fija}>
            <ClientBrand client={cliente} size={28} />
            <span className={styles.nombre} title={cliente.name}>{cliente.name}</span>
          </div>
        ) : null}
      </div>
      <div className={styles.acciones}>
        {rol === "agency" ? (
          <button type="button" className={styles.icono} onClick={onOpenSearch} aria-label="Buscar cliente, sección o acción">
            <NavIcon name="buscar" size={22} />
          </button>
        ) : null}
        <UserMenu email={email} onLogout={onLogout} variante="cabecera" />
      </div>
    </header>
  );
}
